import React from "react";
import styled from "styled-components";
import { FlexDiv } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";

function Filters(props) {
  const { data = {}, filter, setFilter = () => {} } = props || {};
  return (
    <OuterWrap>
      <FilterBtn
        variant="label3"
        onClick={() => filter !== "ALL" && setFilter("ALL")}
        isActive={filter === "ALL"}
        color={
          filter === "ALL" ? theme.colors.white : theme.colorsV2.gray.shade_500
        }
      >
        View All
      </FilterBtn>
      {Object.values(data)?.map((item, index) => {
        return (
          <FilterBtn
            key={index}
            variant="label3"
            onClick={() =>
              filter !== item.dept_name && setFilter(item.dept_name)
            }
            isActive={filter === item.dept_name}
            color={
              filter === item.dept_name
                ? theme.colors.white
                : theme.colorsV2.gray.shade_500
            }
          >
            {item?.dept_name_display}
          </FilterBtn>
        );
      })}
    </OuterWrap>
  );
}

export default Filters;
const OuterWrap = styled(FlexDiv)`
  flex-wrap: wrap;
  margin: 0 -6px;
  width: 100%;
  justify-content: center;
`;
const FilterBtn = styled(Typography)`
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 10px;
  transition: all 0.3s ease-in-out;
  margin: 4px 6px;
  user-select: none;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colorsV2.purple.shade_700 : theme.colorsV2.gray.shade_100};
  ${({ isActive, theme }) =>
    isActive &&
    `
    box-shadow:0px 10px 20px rgba(${theme.colors.shadows.purple_3}, 0.18), 0px 2px 6px rgba(${theme.colors.shadows.purple_3}, 0.12), 0px 0px 1px rgba(${theme.colors.shadows.black}, 0.04);
    `}
`;
